import { Box, useMediaQuery } from '@mui/material';
import React from 'react';

export default function PartnerCard(props) {
    const matches = useMediaQuery('(min-width: 500px)');

    return(
        <Box sx={{m: 2}}>
            <a href={props.link} target="_blank">
                <img src={props.src} alt={"Logo of " + props.name} width={matches ? "330px" : "220px"}/>
            </a>
        </Box>
    )
}